import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { StatusTransitionCodes } from 'api/types';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import config from '../config';
import { Duration } from '../constants';

async function getStatusTransition(axios: AxiosInstance): Promise<StatusTransitionCodes> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/utilities/status-transitions`);
  return data;
}

export default function useStatusTransitionQuery() {
  const axios = useAxios();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getStatusTransition(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    staleTime: Duration.Minute * 60,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as any;
      if (error?.response?.status !== 503) {
        manageErrorResponse(toast, error);
      }
      if (error?.response?.status >= 500 && error?.response?.status !== 503) {
        navigate('/app/errorPage', { replace: true });
      }
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

export function getKey() {
  return ['StatusTransition'] as const satisfies QueryKey;
}
